export const ROLLOVER_HOUR = 4;

/** Start (ms) of the "study day" containing `now`; days roll over at `rolloverHour` local time. */
export function studyDayStart(now = Date.now(), rolloverHour = ROLLOVER_HOUR) {
  const d = new Date(now);
  const start = new Date(d.getFullYear(), d.getMonth(), d.getDate(), rolloverHour, 0, 0, 0);
  if (d < start) start.setDate(start.getDate() - 1);
  return start.getTime();
}

export function studyDayEnd(now = Date.now(), rolloverHour = ROLLOVER_HOUR) {
  const start = new Date(studyDayStart(now, rolloverHour));
  start.setDate(start.getDate() + 1);
  return start.getTime();
}

export function dayKey(ms = Date.now()) {
  const d = new Date(ms);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
